import React from 'react';
import styled, { css } from 'styled-components';

import { Nullable } from '@tager/web-core';

import { media } from '@/utils/mixin';
import { Investment, PostFull, Stock } from '@/typings/model';

type Props = {
  url: string;
  label: string;
};

function WidgetButton({ url, label }: Props) {
  return (
    <ButtonBlock>
      <Button href={url.replace(/&amp;/g, '&')} target="_blank">
        {label}
      </Button>
    </ButtonBlock>
  );
}

const ButtonBlock = styled.div`
  padding: 20px 0;
`;

const Button = styled.a`
  padding: 17px 45px;
  border-radius: 35px;
  background: var(--blue-color);
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  box-shadow: 0 5px 10px 0 #0000002b;
  cursor: pointer;
  &:hover {
    background: #0e5bb6;
  }
`;

export default WidgetButton;
